/* eslint-disable react/no-array-index-key */
import React, { lazy, Suspense, Fragment } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import DocsLayout from 'src/layouts/DocsLayout';
import MainLayout from 'src/layouts/MainLayout';
import HomeView from 'src/views/pages/HomeView';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/Guard/AuthGuard';
import GuestGuard from 'src/components/Guard/GuestGuard';
// import AdminGuard from './components/Guard/AdminGuard';
// import FireGuard from './components/Guard/FireGuard';
// import AssessorGuard from './components/Guard/AssessorGuard';
// import EngineeringGuard from './components/Guard/EngineeringGuard';
// import MenroGuard from './components/Guard/MenroGuard';
// import MaoGuard from './components/Guard/MaoGuard';
// import MpdoGuard from './components/Guard/Mpdoguard';
// import RhuGuard from './components/Guard/RhuGuard';
// import PesoGuard from './components/Guard/PeroGuard';
// import BarangayGuard from './components/Guard/BarangayGuard';
// import BploGuard from './components/Guard/BploGuard';
// import TreasuryGuard from './components/Guard/TreasuryGuard';
// import HousingGuard from './components/Guard/HousingGuard';
// import VmsGuard from './components/Guard/VmsGuard';
// import AemsGuard from './components/Guard/AemsGuard';
import AlagangABCGuard from './components/Guard/AlagangABCGuard';

const routesConfig = [
  {
    exact: true,
    path: '/',
    component: () => <Redirect to="/home" />
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/recover/password',
    component: lazy(() => import('src/views/auth/RecoverPasswordView'))
  },

  {
    exact: true,
    guard: GuestGuard,
    path: '/recover/password/reset-form/:email/:token',
    component: lazy(() =>
      import('src/views/auth/RecoverPasswordView/NewPasswordView/')
    )
  },

  {
    exact: true,
    path: '/register-unprotected',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },

  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app',
        component: () => <Redirect to="/app/reports/dashboard" />
      },
      {
        exact: true,
        path: '/app/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/app/reports/dashboard',
        component: lazy(() => import('src/views/reports/DashboardView'))
      },
      {
        exact: true,
        path: '/app/management/companies',
        component: lazy(() => import('src/views/management/Companies'))
      },
      {
        exact: true,
        path: '/app/management/companies/create',
        component: lazy(() => import('src/views/management/Companies/Create'))
      },
      {
        exact: true,
        path: '/app/management/companies/payment/history',
        component: lazy(() => import('src/views/reports/DashboardView/history'))
      },
      {
        exact: true,
        path: '/app/management/companies/account/soa',
        component: lazy(() => import('src/views/reports/DashboardView/soa'))
      },
      {
        exact: true,
        path: '/app/management/companies/sentattachment/:type/:brgycode',
        component: lazy(() =>
          import('src/views/management/Companies/RequestRegistration')
        )
      },
      {
        exact: true,
        path: '/app/management/companies/edit/:company_code',
        component: lazy(() => import('src/views/management/Companies/Edit'))
      },
      // {
      //   exact: true,
      //   path: '/app/management/companies/assessment/details/currentdue/payment/notifications',
      //   component: lazy(() => import('src/views/management/Companies/Assessment/Details/SampleNotification'))
      // },

      {
        exact: true,
        path: '/app/management/companies/holdings/location/:type/:company_code',
        component: lazy(() => import('src/views/pages/location'))
      },

      {
        exact: true,
        path: '/app/management/companies/assessment/:company_code',
        component: lazy(() =>
          import('src/views/management/Companies/Assessment')
        )
      },
      {
        exact: true,
        path:
          '/app/management/companies/assessment/request/requirements/sent/:assessment_id/:brgycode/:company_name',
        component: lazy(() =>
          import('src/views/management/Companies/Assessment/Requirements')
        )
      },
      {
        exact: true,
        path: '/app/management/companies/assessment/request/:company_code',
        component: lazy(() =>
          import('src/views/management/Companies/Assessment/Request')
        )
      },
      {
        exact: true,
        path:
          '/app/management/companies/assessment/details/:assessment_code/:company_code',
        component: lazy(() =>
          import('src/views/management/Companies/Assessment/Details')
        )
      },
      {
        exact: true,
        path:
          '/app/management/companies/assessment/details/:assessment_code/:company_code/',
        component: lazy(() =>
          import('src/views/management/Companies/Assessment/Details')
        )
      },
      {
        exact: true,
        path:
          '/app/management/companies/assessment/details/paymentsuccessful/:assessment_code/:company_code',
        component: lazy(() =>
          import(
            'src/views/management/Companies/Assessment/Details/PaynamicPaymentSuccessful'
          )
        )
      },
      {
        exact: true,
        path:
          '/app/management/companies/assessment/details/currentdue/payments/gcash/redirect/failed',
        component: lazy(() =>
          import(
            'src/views/management/Companies/Assessment/Details/PaymentDialogGcashRedirectFailed'
          )
        )
      },
      {
        exact: true,
        path:
          '/app/management/companies/assessment/edit/:assessment_code/:company_code',
        component: lazy(() =>
          import('src/views/management/Companies/Assessment/Edit')
        )
      },
      {
        exact: true,
        path: '/app/calendar',
        component: lazy(() => import('src/views/calendar/CalendarView'))
      },
      {
        exact: true,
        path: '/app/kanban',
        component: lazy(() => import('src/views/kanban/KanbanView'))
      },
      {
        exact: true,
        path: ['/app/chat/new', '/app/chat/:threadKey'],
        component: lazy(() => import('src/views/chat/ChatView'))
      },
      {
        exact: true,
        path: '/app/chat',
        component: () => <Redirect to="/app/chat/new" />
      },
      {
        exact: true,
        path: [
          '/app/mail/label/:customLabel/:mailId?',
          '/app/mail/:systemLabel/:mailId?'
        ],
        component: lazy(() => import('src/views/mail/MailView'))
      },
      {
        exact: true,
        path: '/app/mail',
        component: () => <Redirect to="/app/mail/all" />
      },
      {
        exact: true,
        path: '/app/projects/overview',
        component: lazy(() => import('src/views/projects/OverviewView'))
      },
      {
        exact: true,
        path: '/app/projects/browse',
        component: lazy(() => import('src/views/projects/ProjectBrowseView'))
      },
      {
        exact: true,
        path: '/app/projects/create',
        component: lazy(() => import('src/views/projects/ProjectCreateView'))
      },
      {
        exact: true,
        path: '/app/projects/:id',
        component: lazy(() => import('src/views/projects/ProjectDetailsView'))
      },
      {
        exact: true,
        path: '/app/projects',
        component: () => <Redirect to="/app/projects/browse" />
      },
      {
        exact: true,
        path: '/app/social/feed',
        component: lazy(() => import('src/views/social/FeedView'))
      },
      {
        exact: true,
        path: '/app/social/profile',
        component: lazy(() => import('src/views/social/ProfileView'))
      },
      {
        exact: true,
        path: '/app/social',
        component: () => <Redirect to="/app/social/profile" />
      },
      {
        exact: true,
        path: '/app/extra/charts/apex',
        component: lazy(() => import('src/views/extra/charts/ApexChartsView'))
      },
      {
        exact: true,
        path: '/app/extra/forms/formik',
        component: lazy(() => import('src/views/extra/forms/FormikView'))
      },
      {
        exact: true,
        path: '/app/extra/forms/redux',
        component: lazy(() => import('src/views/extra/forms/ReduxFormView'))
      },
      {
        exact: true,
        path: '/app/extra/editors/draft-js',
        component: lazy(() => import('src/views/extra/editors/DraftEditorView'))
      },
      {
        exact: true,
        path: '/app/extra/editors/quill',
        component: lazy(() => import('src/views/extra/editors/QuillEditorView'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },

  //ALAGANG ABC
  {
    path: '/alagang-abc',
    layout: DashboardLayout,
    guard: AlagangABCGuard,
    routes: [
      {
        exact: true,
        path: '/alagang-abc',
        component: () => <Redirect to="/alagang-abc/dashboard" />
      },
      {
        exact: true,
        path: '/alagang-abc/dashboard',
        component: lazy(() => import('src/views/alagangabc/dashboard'))
      },
      {
        exact: true,
        path: '/alagang-abc/document-tracking',
        component: () => (
          <Redirect to="/alagang-abc/doc-track-admin/documents" />
        )
      },
      {
        exact: true,
        path: '/alagang-abc/prospective-beneficiaries',
        component: lazy(() =>
          import(
            'src/views/alagangabc/dashboard/DashboardProspectiveBeneficiaries'
          )
        )
      },
      {
        exact: true,
        path: '/alagang-abc/command-vote-preview',
        component: lazy(() =>
          import('src/views/alagangabc/dashboard/DashboardCommandVotePreview')
        )
      },

      {
        exact: true,
        path: '/alagang-abc/beneficiaries',
        component: lazy(() => import('src/views/alagangabc/voters'))
      },
      {
        exact: true,
        path: '/alagang-abc/comelec-voters',
        component: lazy(() => import('src/views/alagangabc/comelec-voters'))
      },
      {
        exact: true,
        path: '/alagang-abc/expense',
        component: lazy(() => import('src/views/alagangabc/expense'))
      },
      {
        exact: true,
        path: '/alagang-abc/payout',
        component: lazy(() => import('src/views/alagangabc/ayuda'))
      },
      {
        exact: true,
        path: '/alagang-abc/voters/:voters_id',
        component: lazy(() =>
          import('src/views/alagangabc/voters/full-details')
        )
      },
      {
        exact: true,
        path: '/alagang-abc/map',
        component: lazy(() => import('src/views/alagangabc/map'))
      },
      {
        exact: true,
        path: '/alagang-abc/configs',
        component: lazy(() => import('src/views/alagangabc/configs'))
      },
      {
        exact: true,
        path: '/alagang-abc/report',
        component: lazy(() => import('src/views/alagangabc/report'))
      },
      {
        exact: true,
        path: '/alagang-abc/birthdays',
        component: lazy(() => import('src/views/alagangabc/birthdays'))
      },
      {
        exact: true,
        path: '/alagang-abc/qr-scanner',
        component: lazy(() => import('src/views/alagangabc/scanner'))
      },
      {
        exact: true,
        path: '/alagang-abc/events',
        component: lazy(() => import('src/views/alagangabc/event'))
      },
      {
        exact: true,
        path: '/alagang-abc/users',
        component: lazy(() => import('src/views/alagangabc/users'))
      },
      {
        exact: true,
        path: '/alagang-abc/quick-count',
        component: lazy(() => import('src/views/alagangabc/quick-count'))
      },
      {
        exact: true,
        path: '/alagang-abc/heat-map',
        component: lazy(() => import('src/views/alagangabc/heat-map'))
      },
      //FRONT DESK
      {
        exact: true,
        path: '/alagang-abc/front-desk/voters',
        component: lazy(() =>
          import('src/views/alagangabc/front-desk-voter-list')
        )
      },
      {
        exact: true,
        path: '/alagang-abc/front-desk/voters/:voters_id',
        component: lazy(() =>
          import('src/views/alagangabc/voters/full-details')
        )
      },
      //POLL WATCHER
      {
        exact: true,
        path: '/alagang-abc/poll-watcher/report',
        component: lazy(() =>
          import('src/views/alagangabc/pool-watcher/report')
        )
      },
      //RECEIVER / DOC TRACK
      {
        exact: true,
        path: '/alagang-abc/receiver/documents',
        component: lazy(() => import('src/views/alagangabc/receiver/dashboard'))
      },
      //DOC TRACK ADMIN
      {
        exact: true,
        path: '/alagang-abc/doc-track-admin/documents',
        component: lazy(() => import('src/views/alagangabc/doc-track-admin'))
      }
    ]
  },

  {
    path: '/docs',
    layout: DocsLayout,
    routes: [
      {
        exact: true,
        path: '/docs',
        component: () => <Redirect to="/docs/welcome" />
      },
      {
        exact: true,
        path: '/docs/welcome',
        component: lazy(() => import('src/views/docs/WelcomeView'))
      },
      {
        exact: true,
        path: '/docs/getting-started',
        component: lazy(() => import('src/views/docs/GettingStartedView'))
      },
      {
        exact: true,
        path: '/docs/environment-variables',
        component: lazy(() => import('src/views/docs/EnvironmentVariablesView'))
      },
      {
        exact: true,
        path: '/docs/deployment',
        component: lazy(() => import('src/views/docs/DeploymentView'))
      },
      {
        exact: true,
        path: '/docs/api-calls',
        component: lazy(() => import('src/views/docs/ApiCallsView'))
      },
      {
        exact: true,
        path: '/docs/analytics',
        component: lazy(() => import('src/views/docs/AnalyticsView'))
      },
      {
        exact: true,
        path: '/docs/authentication',
        component: lazy(() => import('src/views/docs/AuthenticationView'))
      },
      {
        exact: true,
        path: '/docs/routing',
        component: lazy(() => import('src/views/docs/RoutingView'))
      },
      {
        exact: true,
        path: '/docs/settings',
        component: lazy(() => import('src/views/docs/SettingsView'))
      },
      {
        exact: true,
        path: '/docs/state-management',
        component: lazy(() => import('src/views/docs/StateManagementView'))
      },
      {
        exact: true,
        path: '/docs/theming',
        component: lazy(() => import('src/views/docs/ThemingView'))
      },
      {
        exact: true,
        path: '/docs/support',
        component: lazy(() => import('src/views/docs/SupportView'))
      },
      {
        exact: true,
        path: '/docs/changelog',
        component: lazy(() => import('src/views/docs/ChangelogView'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '*',
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/home',
        component: HomeView
      },
      {
        exact: true,
        path: '/pricing',
        component: lazy(() => import('src/views/pages/PricingView'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  //** ebps routes **//
  {
    path: '/ebps',
    // layout: '',
    routes: [
      {
        exact: true,
        path: '/registration'
        // component: lazy(() => import('src/ebps/users/Registration'))
      },
      {
        exact: true,
        path: '/ebps/login',
        // layout: MainLayout,
        component: lazy(() => import('src/views/auth/LoginView'))
      }
    ]
  }
];

const renderRoutes = routes =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={props => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      renderRoutes(route.routes)
                    ) : (
                      <Component {...props} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
